import {gql} from '@apollo/client'

export const ADD_COMMISSION_RATE = gql`
  mutation commissionRateCreate($input: commission_rate_input!) {
    commissionRateCreate(input: $input) {
      commissionRate {
        id
      }
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const EDIT_COMMISSION_RATE = gql`
  mutation commissionRateUpdate($id: ID!, $input: commission_rate_input!) {
    commissionRateUpdate(input: $input, id: $id) {
      commissionRate {
        id
      }
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_COMMISION_RATE = gql`
  mutation commissionRateDelete($id: ID!) {
    commissionRateDelete(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`
